var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValuesIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#7F56D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15H19.8C18.1198 15 17.2798 15 16.638 15.327C16.0735 15.6146 15.6146 16.0735 15.327 16.638C15 17.2798 15 18.1198 15 19.8V28.2C15 29.8802 15 30.7202 15.327 31.362C15.6146 31.9265 16.0735 32.3854 16.638 32.673C17.2798 33 18.1198 33 19.8 33H28.2C29.8802 33 30.7202 33 31.362 32.673C31.9265 32.3854 32.3854 31.9265 32.673 31.362C33 30.7202 33 29.8802 33 28.2V25M24 20H28V24M27.5 15.5V14M31.4393 16.5607L32.5 15.5M32.5103 20.5H34.0103M15 25.3471C15.6519 25.4478 16.3199 25.5 17 25.5C21.3864 25.5 25.2653 23.3276 27.6197 20",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon3);
export default __webpack_public_path__ + "static/media/Values_icon_3.a6453d4c53a5d778c255d16886dc8216.svg";
export { ForwardRef as ReactComponent };